import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateProjectUsersCache,
  ProjectUsersCacheEvents,
} from '@monorepo/shared/cacheRegisters/users/projectUsersCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseSetUserIsOrganizationAdminParams = {
  projectId: string;
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export function useSetUserIsOrganizationAdmin({
  projectId,
  config,
}: UseSetUserIsOrganizationAdminParams) {
  return useMutation(Api.setUserIsOrganizationAdmin, {
    ...config,
    onSuccess: (data, variables) => {
      // Org admins inherit Site Admin on every site in the org, so the site
      // role shown in this table changes even though no project role was written.
      invalidateProjectUsersCache(ProjectUsersCacheEvents.UPDATE, {
        projectId,
      });
      return config?.onSuccess?.(data, variables);
    },
    onError: (error, variables, rollback) =>
      config?.onError?.(error, variables, rollback),
  });
}
